import * as React from 'react';
import { observer } from 'mobx-react';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { CardController } from 'src/app/shared/card.controller';
import { MarketEditorController } from 'src/app/general/market/parts/market-editor.controller';

interface Props extends ComponentViewProps<DataSet<DocumentTemplateMarketItem>> {
	onCreateDocumentTemplateMarket: () => Promise<DocumentTemplateMarketItem>;
	mode: ControlMode;
}

@observer
export class DocumentTemplateMarketView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	columns: Column[] = [
		{
			key: 'displayName',
			dataIndex: 'displayName',
			title: 'Name',
			editable: (text: string, record: DocumentTemplateMarketItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<MarketEditorController
							required
							label={null}
							mode={this.props.mode}
							setBusy={this.props.setBusy}
							value={record.marketId}
							onChanged={(item) => {
								record.marketId = item.id;
								record.marketName = item.name;
							}}
						/>
					);
				}

				return <span>{record.marketName}</span>;
			}
		}
	];

	render() {
		const { model, onCreateDocumentTemplateMarket, mode, setBusy } = this.props;
		if (model == null) {
			return null;
		}

		return (
			<CardController
				title="Markets"
				icon="trademark"
				className="card-borderless"
				mode={this.props.mode}
			>
				<DataTableView
					model={model}
					mode={mode}
					setBusy={setBusy}
					columns={this.columns}
					createNewItem={onCreateDocumentTemplateMarket}
					hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hidePagination}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/markets/market.view.tsx